import axios from "axios"
import { isBrowser } from "./util"

export const nextLevelProCreate = (values) => {
    return new Promise(function(resolve, reject) {
        if(!isBrowser()){
            reject("Do not do this from Node!")
        }else{
            const contactSubmitUrl = "https://82qtggfh53.execute-api.us-west-2.amazonaws.com/default/nextlevelprocreate";
            values.env = process.env.GATSBY_DATOCMS_ENV;
            axios.post(
                `${contactSubmitUrl}`,
                values,
                {
                    headers: {
                        'X-Api-Key': 'ucQsN6jJJI23KdYZHaIv1aPHCKMaJmF584JgEnlJ',
                    }
                }
            ).then((result) => {
                resolve(result)
            }).catch((err)=>{
                reject(err)
            })
        }
    })
}